const STORAGE_KEY = "otc-cookie-consent-v1";

export const COOKIE_CATEGORIES = [
  {
    id: "necessari",
    label: "Tecnici necessari",
    locked: true,
    text: "Tengono attivo l’accesso (cookie di sessione firmato) e ricordano la scelta sui cookie. Senza questi la piattaforma non funziona.",
  },
  {
    id: "statistiche",
    label: "Statistiche di utilizzo",
    text: "Ci dicono in forma aggregata quali pagine vengono usate, per capire dove migliorare l’applicativo. Oggi non è attivo alcuno strumento: il consenso resta pronto per quando lo introdurremo.",
  },
  {
    id: "marketing",
    label: "Marketing",
    text: "Misurano l’efficacia delle campagne e permettono contenuti pubblicitari personalizzati. Oggi non è attivo alcuno strumento.",
  },
];

export function readCookieConsent() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function saveCookieConsent(choices) {
  const value = { ...choices, necessari: true, version: 1, decided_at: new Date().toISOString() };
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
  } catch {
    /* archiviazione non disponibile: la scelta vale per la sessione corrente */
  }
  window.dispatchEvent(new CustomEvent("cookie-consent-updated", { detail: value }));
  return value;
}

export function openCookieSettings() {
  window.dispatchEvent(new Event("open-cookie-settings"));
}
